export default {
    buttons: {
        reset_password: 'Change Password',
    },
    fields: {
        password: {
            label: 'Password',
            placeholder: '6 characters minimum',
        },
        password_confirm: {
            label: 'Confirm password',
            placeholder: 'Enter the password again',
        },
    },
    errors: {
        passwords_not_match: 'Passwords do not match',
    },
}
